import {
  BoqStandardStateTypes,
  BoqStandardActionTypes,
} from "./BoqStandard.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: BoqStandardStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const BoqStandardReducer = (
  state: BoqStandardStateTypes = INITIAL_STATE,
  action: any
): BoqStandardStateTypes => {
  switch (action.type) {
    case BoqStandardActionTypes.FETCH_ALL_BOQ_STANDARD:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case BoqStandardActionTypes.FETCH_ALL_BOQ_STANDARD_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case BoqStandardActionTypes.FETCH_ALL_BOQ_STANDARD_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case BoqStandardActionTypes.FETCH_ALL_BOQ_STANDARD_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case BoqStandardActionTypes.FETCH_ONE_BOQ_STANDARD:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case BoqStandardActionTypes.FETCH_ONE_BOQ_STANDARD_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case BoqStandardActionTypes.FETCH_ONE_BOQ_STANDARD_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case BoqStandardActionTypes.FETCH_ONE_BOQ_STANDARD_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default BoqStandardReducer;
